import React from 'react';
import { Button, Dialog, DialogTrigger, DialogContent, DialogFooter } from '@chatsdet/ui';
import type { InterstitialDialogConfig } from '@chatsdet/types';
import type { AnnouncementComponentProps } from './registry';

/**
 * The default announcement surface: a centered interstitial dialog. `body` is
 * rendered as plain text (whitespace preserved) — mirrors the Hints content
 * surface; markdown is a forward-compatible enhancement.
 */
export function InterstitialAnnouncementDialog({
  announcement,
  onDismiss,
}: AnnouncementComponentProps) {
  const config = announcement.config as InterstitialDialogConfig;

  return (
    <DialogTrigger
      isOpen
      onOpenChange={(open) => {
        if (!open) onDismiss();
      }}
    >
      <Button className="hidden">Trigger</Button>
      <Dialog title={config.title}>
        <DialogContent>
          <p className="whitespace-pre-wrap text-sm text-muted-foreground">{config.body}</p>
        </DialogContent>
        <DialogFooter>
          {config.ctaLabel && config.ctaHref && (
            <Button
              variant="outline"
              onPress={() =>
                window.open(config.ctaHref, '_blank', 'noopener,noreferrer')
              }
            >
              {config.ctaLabel}
            </Button>
          )}
          <Button variant="primary" onPress={onDismiss}>
            {config.dismissLabel ?? 'Got it'}
          </Button>
        </DialogFooter>
      </Dialog>
    </DialogTrigger>
  );
}
